import $ from 'jquery'
import { ready } from 'shared/ready'
import { trackInternalEvent } from '@rio/tracking'

class FourOhFourView {
  constructor($el) {
    if ($el.length === 0) return
    this.triggerFourOhFourEvent()
  }

  triggerFourOhFourEvent = () => {
    trackInternalEvent('view_404', {
      website_host: window.location.host,
      label: '404',
      target_url: window.location.href,
    })
  }
}

// ---
// Init
// ---
ready(function () {
  return new FourOhFourView($('.page-404'))
})
